/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import Box, { type BoxProps } from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import classNames from 'classnames';
import LoaderSizes from '@/constants/ui/LoaderSizes';

type LoaderProps = BoxProps & {
  className?: string;
  size?: string;
  isVisible?: boolean;
  isCentered?: boolean;
};

function Loader({
  className = '',
  isVisible = true,
  size = LoaderSizes.LG,
  isCentered = false,
  ...rest
}: LoaderProps) {
  if (!isVisible) {
    return null;
  }

  return (
    <Box
      className={
        isCentered
          ? classNames('flex items-center justify-center', className)
          : className
      }
      {...rest}
    >
      <CircularProgress size={size} data-testid="loader" color="primary" />
    </Box>
  );
}

export default Loader;
